(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["save80-discount-copy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    var button = event.target.closest('.joy-save80-discount__button');

    if (!button) {
      return;
    }

    var wrapper = button.closest('.joy-save80-discount');
    var code = wrapper ? wrapper.getAttribute('data-discount-code') : 'SAVE80';
    var originalText = button.textContent;

    function markCopied() {
      button.textContent = 'Copied';
      button.classList.add('is-copied');

      window.setTimeout(function() {
        button.textContent = originalText;
        button.classList.remove('is-copied');
      }, 1800);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(markCopied);
      return;
    }

    var input = document.createElement('input');
    input.value = code;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    markCopied();
  });
  } catch(e) { console.error(e); }
})();

})();
